import compileSymbols from '~/utils/compileSymbols';

const types = [
  'SAVE_SUCCESS',
  'SAVE_FAILED',
  'CLEAR_DESIGN_DATA',
  'DUPLICATE_DESIGN',
  'SAVE',
  'FETCH',
  'FETCH_SUCCESS',
  'FETCH_FAILED',
  'SHARE',
  'SHARE_SUCCESS',
  'SHARE_FAILURE',
  'SHARE_ERROR',
  'INVALID_UPLOAD',
  'SET_COMBINE_DESIGNS',
  'UPDATE_INK_MATCHES',
  'REMOVE_INK_MATCH',
  'RESET_INK_MATCHES'
];

export default compileSymbols(types, 'design');
